import { makeStyles } from "@material-ui/core";
import { Grid } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { rejectApprovalVisit } from "../../slices/Invitations/InvitationsSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      maxWidth: "600px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));


export default function RejectRegistartionInvitationDialog(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const [payload, setPayload] = React.useState({
    visitorId: props.RejectRegisterId,
    approvalReason: "",
    firstName: props?.rejectVisit?.visitor?.firstName,
    lastName: props?.rejectVisit?.visitor?.lastName,
    module: props?.module,
    subModule: props?.subModule
  });

  const [error, setError] = React.useState({
    approvalReason: false,
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    dispatch(rejectApprovalVisit(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI1029") {
          Toast(t(data.message), "success");
          props.disable();
          handleClose();
        } else {
          Toast(data.message, "error");
          handleClose();
        }
      })
      .catch((er) => { });
  };

  return (
    <>
      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("APPROVE003")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON035")}
        cancelText={t("dataTableCancel")}
        style={{ color: "#3D4977", opacity: 1, minHeight: "" }}
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{
            width: "100%",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid item xs={12}>
            <CustomTextfield
              type={"text"}
              label={t("COMMON016")}
              error={error.approvalReason}
              name="approvalReason"
              value={payload.approvalReason}
              handleChange={(e) => handleChange(e)}
              inputProps={{ maxLength: 120 }}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
